// Copyright (c) Ping. All rights reserved.
//
// Drives the on-demand per-pane settings guide. The floating guide button in
// a settings pane calls `open(pane)`; `PaneGuideHost` watches this and starts
// the matching walkthrough. The nonce bumps on every open so clicking the same
// pane's button twice re-runs the guide.

import { create } from 'zustand';

import type { SettingsTabId } from '@ping/ui/src/settings-modal/types';

interface PaneGuideState {
  readonly pane: SettingsTabId | null;
  readonly nonce: number;
  open(pane: SettingsTabId): void;
}

export const usePaneGuideStore = create<PaneGuideState>((set) => ({
  pane: null,
  nonce: 0,
  open: (pane) => set((state) => ({ pane, nonce: state.nonce + 1 })),
}));
